import React, { useEffect, useState } from "react";
import { useTheme } from "../theme/ThemeContext";
import { useAuth } from "../auth/AuthContext";
import { API_BASE } from "../api";

const Login = () => {
  const { tokens, fonts } = useTheme();
  const { login, signup } = useAuth();
  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [codeRequired, setCodeRequired] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const isSignup = mode === "signup";

  useEffect(() => {
    fetch(`${API_BASE}/auth-config`)
      .then((res) => (res.ok ? res.json() : {}))
      .then((data) => setCodeRequired(!!data.signupCodeRequired))
      .catch(() => {});
  }, []);

  const switchMode = () => {
    setMode(isSignup ? "login" : "signup");
    setError("");
    setPassword("");
    setConfirm("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    if (isSignup && password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      if (isSignup) await signup(username.trim(), email.trim(), password, inviteCode.trim());
      else await login(username.trim(), password);
    } catch (err) {
      setError(err.message === "Failed to fetch" ? "Cannot reach the server." : err.message);
      setBusy(false);
    }
  };

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    marginBottom: 10,
    padding: "12px 14px",
    fontSize: 15,
    borderRadius: 10,
    border: `1px solid ${tokens.surfaceBorder}`,
    backgroundColor: tokens.bg,
    color: tokens.textPrimary,
    outline: "none",
  };

  const disabled = busy || !username || !password || (isSignup && (!confirm || !email));

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backgroundColor: tokens.bg, fontFamily: fonts.body }}>
      <form
        onSubmit={handleSubmit}
        style={{ width: "100%", maxWidth: 360, padding: 28, borderRadius: 16, backgroundColor: tokens.surface, border: `1px solid ${tokens.surfaceBorder}`, boxShadow: tokens.cardShadow }}
      >
        <h1 style={{ margin: 0, fontFamily: fonts.display, fontSize: 24, color: tokens.textPrimary }}>budgetsprint</h1>
        <p style={{ margin: "6px 0 20px", fontSize: 14, color: tokens.textMuted }}>
          {isSignup ? "Create your account." : "Sign in with your email and password."}
        </p>

        {isSignup && (
          <input
            autoFocus
            type="email"
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
        )}
        <input
          type="text"
          autoFocus={!isSignup}
          autoCapitalize="none"
          autoCorrect="off"
          autoComplete={isSignup ? "username" : "email"}
          placeholder={isSignup ? "Choose a username" : "Email"}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={inputStyle}
        />
        <input
          type="password"
          autoComplete={isSignup ? "new-password" : "current-password"}
          placeholder={isSignup ? "Password (at least 10 characters)" : "Password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />
        {isSignup && (
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Confirm password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={inputStyle}
          />
        )}
        {isSignup && codeRequired && (
          <input
            type="text"
            autoCapitalize="none"
            autoCorrect="off"
            placeholder="Invite code"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value)}
            style={inputStyle}
          />
        )}

        {error && <div role="alert" style={{ marginBottom: 4, fontSize: 13, color: tokens.negative }}>{error}</div>}

        <button
          type="submit"
          disabled={disabled}
          style={{ marginTop: 10, width: "100%", padding: "12px 14px", fontSize: 15, fontWeight: 600, border: "none", borderRadius: 10, cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1, backgroundColor: tokens.accent, color: tokens.accentContrast }}
        >
          {busy ? "Please wait…" : isSignup ? "Create account" : "Sign in"}
        </button>

        <button
          type="button"
          onClick={switchMode}
          style={{ marginTop: 14, width: "100%", padding: 6, fontSize: 13, background: "none", border: "none", cursor: "pointer", color: tokens.textMuted, fontFamily: fonts.body }}
        >
          {isSignup ? "Already have an account? Sign in" : "New here? Create an account"}
        </button>
      </form>
    </div>
  );
};

export default Login;
